<template>
  <wrapper @clear="clear()" :showClear="showClear" :filter="filter">
    <div class="filters__range">
      <div class="range__min">
        <input type="text" v-model.lazy="min_value" placeholder="od"/>
      </div>
      <div class="range__separator">-</div>
      <div class="range__max">
        <input type="text" v-model.lazy="max_value" placeholder="do"/>
      </div>
    </div>
  </wrapper>
</template>

<script>
import wrapper from "./Wrapper.vue";

export default {
  name: "range",
  components: {
    wrapper: wrapper
  },
  props: {
    filters: Array,
    filter: Object
  },
  data() {
    return {
      min_value: "",
      max_value: "",
      watch : false
    };
  },
  mounted() {
    let values = this.filter.filter.values;
    if (values.min) {
      this.min_value = values.min;
    }
    if (values.max) {
      this.max_value = values.max;
    }

    this.watch = true;
  },
  computed: {
    showClear() {
      return Object.values(this.filter.filter.values).length > 0;
    },
  },
  emits: ["change"],
  watch: {
    filter: function () {
      let values = this.filter.filter.values;
      this.min_value = values.hasOwnProperty('min') ? values.min : null;
      this.max_value = values.hasOwnProperty('max') ? values.max : null;
    },
    min_value: function () {
      if(!this.watch) {
        return;
      }

      let values = this.filter.filter.values;
      if (this.min_value && values.min !== this.min_value) {
        values.min = this.min_value;
        this.$emit("change");
      }

      if (!this.min_value && values.min) {
        delete values.min;
        this.$emit("change");
      }
    },
    max_value: function () {
      if(!this.watch) {
        return;
      }

      let values = this.filter.filter.values;
      if (this.max_value && values.max !== this.max_value) {
        values.max = this.max_value;
        this.$emit("change");
        console.log('max change')
      }

      if (!this.max_value && values.max) {
        delete values.max;
        this.$emit("change");
        console.log('max change')
      }
    }
  },
  methods: {
    clear() {
      this.filter.filter.values = {};
      this.$emit('change');
    }
  }
};
</script>
